import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomHeading.module.scss';
import { POSITION_TYPE } from '@/constants/blog';

const possibleHeadingLevel = [1, 2, 3, 4, 5];

const CustomHeading = ({ title, headingLevel, labelPosition = POSITION_TYPE.CENTER, customClassName }) => {
  const Heading = headingLevel && possibleHeadingLevel.includes(headingLevel) ? `h${headingLevel}` : 'h1';

  const className = [
    styles['container'],
    customClassName?.['label'],
    styles[`position-${labelPosition === POSITION_TYPE.START ? 'start' : 'center'}`],
  ].filter(Boolean).join(' ');

  return (
    <Heading className={className}>{title}</Heading>
  );
};

CustomHeading.propTypes = {
  title: PropTypes.string.isRequired,
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5]),
  labelPosition: PropTypes.oneOf([POSITION_TYPE.CENTER, POSITION_TYPE.START]),
  customClassName: PropTypes.object
};

export default CustomHeading;
